<template>
    <div class="panel panel-visible widget-client_subs">
        <div class="panel-heading">
            <div class="panel-title hidden-xs">
                <span class="fa fa-money"/>
                Долги
            </div>

        </div>
        <div class="panel-body">
            <table class="table table-striped table-hover debts">
                <thead>
                <tr>
                    <th> Задолженность</th>
                    <th> Оплатить до</th>
                    <th> Статус</th>
                    <th> </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(debt, index) in client.debts" v-bind:key="index">
                    <td>{{debt.debt | numberFormat(0)}}</td>
                    <td>{{debt.expireDate | dateFormat('dd.mm.yyyy')}}</td>
                    <td>
                        <span class="label" :class="{'label-success': debt.status === 2, 'label-danger': debt.status === 1}">
                            {{debt.status === 1 ? 'Открыт' : 'Закрыт'}}
                        </span>
                    </td>
                    <td>
                        <button v-if="debt.status === 1" v-on:click.prevent="debtCloseShowModal(debt)" type="button" class="btn btn-xs btn-warning">Закрыть</button>
                    </td>
                </tr>
                <tr v-show="client.debts.length === 0">
                    <td colspan="4" class="text-center">Нет задолжностей</td>
                </tr>
                </tbody>
            </table>
        </div>


        <modal name="close-debt" height="auto">
            <loading :active.sync="modals.closeDebt.isLoading" :z-index="3" color="#4c4a49" :is-full-page="false"/>
            <div class="panel panel-visible" v-if="modals.closeDebt.debt">
                <div class="panel-heading">
                    <div class="panel-title hidden-xs">
                        <span class="fa fa-money"/>
                        Закрытие долга
                    </div>

                </div>
                <div class="panel-body admin-form">
                    <div class="row section">
                        <div class="col-md-10">
                            <label class="field-label">Сумма</label>
                            <label class="field prepend-icon">
                                <input type="text" class="gui-input" readonly :value="modals.closeDebt.drop === false ? modals.closeDebt.debt.debt : 0">
                                <label class="field-icon">
                                    <i class="glyphicon glyphicon-rub"/>
                                </label>
                            </label>
                        </div>
                        <div class="col-md-2">
                            <label class="field-label">Списать</label>
                            <label class="switch switch-primary">
                                <input type="checkbox" id="form-client-modal-debt-drop" v-model="modals.closeDebt.drop" value="1">
                                <label for="form-client-modal-debt-drop" data-on="Да" data-off="Нет"></label>
                            </label>
                        </div>
                    </div>
                    <div class="row section" v-if="modals.closeDebt.drop === true">
                        <div class="col-md-12">
                            <label class="field-label">Комментарий</label>
                            <label class="field prepend-icon">
                                <textarea class="gui-textarea" v-model="modals.closeDebt.comment"></textarea>
                                <label class="field-icon">
                                    <i class="fa fa-edit"></i>
                                </label>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label class="field-label">Тип платежа</label>
                            <label class="field select">
                                <select v-model="modals.closeDebt.paymentType">
                                    <option v-for="(type, index) in this.data.paymentTypes" v-bind:key="index" :value="type.id">
                                        {{type.name}}
                                    </option>
                                </select>

                                <i class="arrow double"/>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="panel-footer admin-form">
                    <button type="button" v-on:click.prevent="debtClose" class="button btn-primary">Сохранить</button>
                </div>

            </div>
        </modal>

    </div>
</template>

<script>
    import Client from '../../models/Client';
    import Cashflow from "../../models/Cashflow";
    import Debt from "../../models/Debt";
    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
        },
        props: {
            client: Client,
        },
        data() {
            return {
                data: {
                    paymentTypes: Cashflow.getTypesPayment(),
                },
                modals: {
                    closeDebt: {
                        isLoading: false,
                        debt: null,
                        drop: false,
                        comment: '',
                        paymentType: Cashflow.PAYMENT_TYPE_CASH,
                    },
                },
            };
        },
        methods: {

            debtCloseShowModal(debt) {
                this.modals.closeDebt.debt = debt;
                this.$modal.show('close-debt');
            },
            async debtClose() {
                let sum = Number(this.modals.closeDebt.debt.debt);
                if (isNaN(sum) === true) {
                    return;
                }
                const comment = this.modals.closeDebt.comment.trim();
                if (this.modals.closeDebt.drop === true && comment.length === 0) {
                    return;
                }

                if (this.modals.closeDebt.drop === true) {
                    this.modals.closeDebt.debt.debt = 0;
                }

                this.modals.closeDebt.isLoading = true;

                this.modals.closeDebt.debt.status = Debt.STATUS_CLOSE;
                await this.modals.closeDebt.debt.close(this.modals.closeDebt.paymentType, this.modals.closeDebt.drop, comment);

                this.modals.closeDebt.isLoading = true;

                this.$modal.hide('close-debt');
            },
        },
    }
</script>